var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pre',{staticClass:"talk-text font-14 margin-b-5 padding-rl-5",domProps:{"innerHTML":_vm._s(_vm.item.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }